// extracted by mini-css-extract-plugin
export default {"bills":"totalamt_bills__USed+","amtlist":"totalamt_amtlist__xgGzV"};